import {getDataLine} from "./utils_dataTables";
import {createIcon, disableButton} from "./utils_element";
import {appRequest} from "./utils_request";

export const init = () => {
    $('#dataTable').on('draw.dt', (e) => {
        $('button.btn-check-color').off('click');
        $('button.btn-check-color').click(e => {
            if (e.currentTarget.querySelector('.fa-square')){
                initCheckColor(e, 'COULEUR');
            }
        });

        $('button.btn-check-type-comm').off('click');
        $('button.btn-check-type-comm').click(e => {
            if (e.currentTarget.querySelector('.fa-square')){
                initCheckColor(e, 'TYPE_COMM');
            }
        });
    });
};

const initCheckColor = (e, checkType) => {
    let dataLine = getDataLine(e),
        submitBtn = e.currentTarget;

    disableButton(submitBtn,true);
    appRequest(urls.addVehicleCheck, {DocEntryVH: dataLine.data['DocEntryVH'], CheckType : checkType})
        .then(r => {
            disableButton(submitBtn, false);
            if (r.success){
                submitBtn.innerHTML = createIcon('fal fa-check-square fa-2x').outerHTML;
                $(submitBtn).off('click');
                return;
            }
            submitBtn.innerHTML = createIcon('fal fa-square fa-2x').outerHTML;
            alert('Le check n\'a pas été enregistrée');
        });

};


// WEBPACK FOOTER //
// ./assets/js/display_gestion_parc.js